const ShippingCompaniesTableDetails = ({ index, details, onCostChange }) => {
  return (
    <tr className="text-sm text-center text-gray-800 bg-white border-b">
      <td className="py-2">{index}</td>
      <td className="py-2">{details.country}</td>
      <td className="flex items-center justify-center gap-2 py-2">
        <input
          type="number"
          value={details.cost}
          onChange={(e) => onCostChange(parseFloat(e.target.value))}
          className="py-1 text-center text-black bg-gray-100 border rounded-md "
        />
        $
      </td>
    </tr>
  );
};
export default ShippingCompaniesTableDetails;
